module.exports = __webpack_public_path__ + "static/media/2.173c2381.png";